export default "__VITE_ASSET__BJpvepJf__"